import React from 'react';

import { AhvOppfolgingDTO } from '../../generated-types';
import { useTranslation } from '../../translations';
import { TaskExpandCard } from '../TaskExpandCard';
import { AntiMoneyLaunderingError } from './AntiMoneyLaunderingError';
import { AntiMoneyLaunderingOK } from './AntiMoneyLaunderingOK';
import { AntiMoneyLaunderingTask } from './AntiMoneyLaunderingTask';

import './AntiMoneyLaunderingAssignment.scss';

interface AntiMoneyLaunderingAssignmentProps {
    antiMoneyLaunderingAssignments: AhvOppfolgingDTO[];
    ahvOk?: boolean;
    ahvError?: boolean;
}
const AntiMoneyLaunderingAssignment = ({
    antiMoneyLaunderingAssignments,
    ahvOk,
    ahvError,
}: AntiMoneyLaunderingAssignmentProps) => {
    const { antiMoneyLaunderingTask } = useTranslation();
    return (
        <>
            {ahvOk && <AntiMoneyLaunderingOK />}
            {ahvError && <AntiMoneyLaunderingError />}
            {antiMoneyLaunderingAssignments.map((antiMoneyLaunderingAssignment) => (
                <TaskExpandCard
                    key={antiMoneyLaunderingAssignment.oppfolgingUrl}
                    title={antiMoneyLaunderingTask.title}
                    description={antiMoneyLaunderingAssignment.oppfolgingHeader ?? ''}
                    tasks={
                        <AntiMoneyLaunderingTask
                            cardBodyText={antiMoneyLaunderingAssignment.cardBodyText ?? ''}
                            linkLabelText={antiMoneyLaunderingAssignment.linkLabelText ?? ''}
                            linkContentText={antiMoneyLaunderingAssignment.linkContentText ?? ''}
                            oppfolgingUrl={antiMoneyLaunderingAssignment.oppfolgingUrl ?? ''}
                        />
                    }
                />
            ))}
        </>
    );
};

export default AntiMoneyLaunderingAssignment;
